import React, { useState, useEffect, useContext } from 'react'
import { deleteBankbyId, getBanks, getBanksByCountryId } from '../api/banks'
import { AuthContext } from '../context/AuthContext';

export const useBank = () => {
    const { setLoading,checkToken } = useContext(AuthContext);
    const [banks, setBanks] = useState([]);
    const [selectCard, setSelectCard] = useState(null);


    const getBank = async () => {
        checkToken()
        try {
            setLoading(true)
            const { data } = await getBanks();
            console.log(data.data)
            setLoading(false)
            setBanks([...data.data]);
        } catch (e) {
            setLoading(false)
            //console.log(e.response?._response);
        }
    }

    const deleteBank = async (bankId) => {
        checkToken()
        try {
            setLoading(true);
            const { data } = await deleteBankbyId(bankId);
            setBanks([...banks, data.data]);
            setLoading(false);
            return (true)
        }
        catch (e) {
            setLoading(false);
            //console.log(e.response?._response);
            return (false)
        }
    }

    const getBankByCountry = async (countryId) => {
        checkToken()
        try {
            setLoading(true);
            const { data } = await getBanksByCountryId(countryId);
            setBanks([...data.data])
            setSelectCard({ index: 0, id: data.data[0].id });
            setLoading(false);
            return (true)
        }
        catch (e) {
            setLoading(false);
            //console.log(e.response?._response);
            return (false)
        }
    }

    return {
        getBank,
        setBanks,
        banks,
        deleteBank,
        getBankByCountry,
        selectCard, setSelectCard
    }
}